import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=fb131c30&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=fb131c30&prod&lang=scss&scoped=true"
import style1 from "./invoice.vue?vue&type=style&index=1&id=fb131c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb131c30",
  null
  
)

export default component.exports